import { render, staticRenderFns } from "./templateAdd.vue?vue&type=template&id=ebd19dde&scoped=true&"
import script from "./templateAdd.vue?vue&type=script&lang=ts&"
export * from "./templateAdd.vue?vue&type=script&lang=ts&"
import style0 from "./templateAdd.vue?vue&type=style&index=0&id=ebd19dde&prod&lang=scss&scoped=true&"
import style1 from "./templateAdd.vue?vue&type=style&index=1&id=ebd19dde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd19dde",
  null
  
)

export default component.exports